module.exports = __webpack_public_path__ + "img/listing-new-3.ea77656.png";